(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-vos-mots]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-vm-card]')];
      const filters = [...root.querySelectorAll('[data-vm-filter]')];
      const more = root.querySelector('[data-vm-more]');
      const empty = root.querySelector('[data-vm-empty]');
      const status = root.querySelector('[data-vm-status]');
      const pageSize = Number(root.dataset.pageSize) || 6;
      let category = 'all', limit = pageSize;
      const update = () => {
        const matches = cards.filter(card => category === 'all' || card.dataset.category === category);
        const visible = new Set(matches.slice(0, limit));
        cards.forEach(card => { card.hidden = !visible.has(card); });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.vmFilter === category)));
        more.hidden = matches.length <= limit;
        empty.hidden = cards.length > 0 || matches.length > 0;
        status.textContent = matches.length ? root.dataset.count.replace('__COUNT__', String(matches.length)) : cards.length || category !== 'all' ? root.dataset.empty : '';
      };
      filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.vmFilter; limit = pageSize; update(); }));
      more.addEventListener('click', () => {
        const previous = limit;
        limit += pageSize;
        update();
        const matches = cards.filter(card => category === 'all' || card.dataset.category === category);
        const firstNew = matches[previous];
        if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({ preventScroll: true }); }
      });
      root.querySelectorAll('.vm-collection__form').forEach(form => {
        const message = form.querySelector('[data-word-message]');
        const topic = form.querySelector('[data-word-topic]');
        const consent = form.querySelector('[data-word-consent]');
        const healthConsent = form.querySelector('[data-word-health-consent]');
        const payload = form.querySelector('[data-word-payload]');
        const submit = form.querySelector('[data-word-submit]');
        if (!message || !topic || !consent || !healthConsent || !payload || !submit) return;
        message.addEventListener('input', () => message.setCustomValidity(''));
        submit.disabled = false;
        form.addEventListener('submit', event => {
          // Native Shopify fields and anti-spam remain intact. Only published
          // comments with this exact versioned consent marker enter the feed.
          message.setCustomValidity('');
          if (message.value.includes('[NISSI_META_V1]') || message.value.includes('|||NISSI_LINE|||')) {
            message.setCustomValidity('Merci de retirer les marqueurs techniques de ton message.');
          }
          if (!form.checkValidity() || !consent.checked || !healthConsent.checked) {
            event.preventDefault();
            form.reportValidity();
            return;
          }
          payload.value = message.value.trim() + '\n\n[NISSI_META_V1]' + topic.value + '|publication=oui|alias=oui|sante=oui';
        });
      });
      update();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

